import Footer from "@/components/Footer";
import Header from "@/components/Header";
import Seo from "@/components/Seo";

const Privacy = () => {
  return (
    <div className="min-h-screen bg-background">
      <Seo
        title="Política de Privacidade | Quimical"
        description="Entenda como a Quimical coleta, utiliza e protege dados pessoais em seus canais digitais e serviços."
        canonical="https://quimical.com.br/privacidade"
      />
      <Header />
      
      <main className="pt-20">
        <div className="container mx-auto px-4 py-16">
          <div className="max-w-4xl mx-auto">
            <h1 className="text-4xl font-bold text-foreground mb-8">
              Política de Privacidade
            </h1>
            
            <div className="prose prose-gray max-w-none">
              <p className="text-muted-foreground mb-6">
                Última atualização: 15 de julho de 2026
              </p>

              <section className="mb-8">
                <p className="text-muted-foreground leading-relaxed mb-4">
                  Todas as suas informações pessoais recolhidas, serão usadas para o ajudar a tornar a sua visita ao
                  nosso site a mais produtiva, segura e agradável possível.
                </p>
                <p className="text-muted-foreground leading-relaxed mb-4">
                  A garantia da confidencialidade e da proteção dos dados pessoais dos utilizadores do nosso site é
                  um compromisso da QUIMICAL. Todas as informações pessoais relativas a membros, fornecedores,
                  clientes, visitantes ou demais usuários que utilizem o site da QUIMICAL serão tratadas em
                  concordância a Lei Geral de Proteção de Dados Pessoais - LGPD nº 13.709, de 14 de agosto de 2018,
                  com as alterações promovidas pela Lei nº 13.853, de 8 de julho de 2019 e demais normas aplicáveis.
                  As informações pessoais recolhidas poderão incluir nome, e-mail, número de telefone e/ou celular,
                  endereço, data de nascimento, empresa e outros dados necessários para o atendimento, prestação de
                  serviços, cumprimento de obrigações legais ou execução de contratos.
                </p>
                <p className="text-muted-foreground leading-relaxed">
                  O uso do presente site da QUIMICAL pressupõe a aceitação desta política de privacidade. A equipe
                  da QUIMICAL reserva-se ao direito de alterar este documento a qualquer momento, sem aviso prévio.
                  Deste modo, recomendamos que consulte a nossa política de privacidade periodicamente, de forma a
                  estar sempre atualizado quanto às suas disposições.
                </p>
              </section>

              <section className="mb-8">
                <h2 className="text-2xl font-semibold text-foreground mb-4">
                  Os Anúncios e Rastreamento
                </h2>
                <p className="text-muted-foreground leading-relaxed">
                  Tal como outros websites, coletamos e utilizamos informações de navegação, incluindo endereço IP
                  (Internet Protocol), o ISP (Internet Service Provider, como o Sapo, Clix, ou outro), o navegador
                  que utilizou ao visitar o nosso website (Browser), data e horário de acesso, o tempo da visita e
                  páginas visitadas dentro do nosso website. Essas informações são utilizadas para melhorar a
                  experiência do usuário, garantir a segurança das informações e aperfeiçoar continuamente nossos
                  serviços.
                </p>
              </section>

              <section className="mb-8">
                <h2 className="text-2xl font-semibold text-foreground mb-4">
                  Os Cookies e Web Beacons
                </h2>
                <p className="text-muted-foreground leading-relaxed mb-4">
                  Utilizamos cookies para armazenar informação, tais como as suas preferências pessoais durante a
                  navegação em nosso website. Isto poderá incluir um simples popup, ou uma ligação em vários
                  serviços que providenciamos, tais como fóruns, chats e FAQ. Poderemos utilizar tecnologias como os
                  cookies e/ou web beacons quando publicitam no nosso website, o que fará com que esses
                  publicitários (como o Google através do Google Adds) também recebam a sua informação pessoal,
                  como o endereço IP, o seu ISP, o seu browser, etc. Esta função é geralmente utilizada para
                  geotargeting (mostrar publicidade de São Paulo apenas aos leitores oriundos de São Paulo por ex.)
                  ou apresentar publicidade direcionada a um tipo de utilizador (como mostrar publicidade de
                  restaurante a um utilizador que visita sites de culinária regularmente, por ex.).
                </p>
                <p className="text-muted-foreground leading-relaxed">
                  Você detém o poder de desligar os seus cookies, nas opções do seu browser, ou efetuando alterações
                  nas ferramentas de programas Anti-Virus, como o Norton Internet Security. No entanto, isso poderá
                  alterar a forma como interage com o nosso website, ou outros websites. Isso poderá afetar ou não
                  permitir que faça logins em programas, sites ou fóruns da nossa e de outras redes.
                </p>
              </section>

              <section className="mb-8">
                <h2 className="text-2xl font-semibold text-foreground mb-4">
                  Ligações e Sites de Terceiros
                </h2>
                <p className="text-muted-foreground leading-relaxed">
                  O QUIMICAL possui ligações para outros sites, os quais, a nosso ver, podem conter informações ou
                  ferramentas úteis para os nossos visitantes. A nossa política de privacidade não é aplicada a
                  sites de terceiros, pelo que, caso visite outro site a partir do nosso deverá ler a politica de
                  privacidade do mesmo. Não nos responsabilizamos pela política de privacidade ou pelo conteúdo
                  disponibilizado nesses sites.
                </p>
              </section>

              <section className="mb-8">
                <h2 className="text-2xl font-semibold text-foreground mb-4">
                  Registros de Ligações
                </h2>
                <p className="text-muted-foreground leading-relaxed">
                  Toda e qualquer comunicação com a QUIMICAL seja pelo telefone 0800 591 7215 ou números de
                  WhatsApp, e-mail, ou outros canais de atendimento, é monitorada pela QUIMICAL para fins de
                  segurança, melhoria da qualidade dos serviços, comprovação de negociações e cumprimento de
                  obrigações. Os seus diálogos são protegidos e nos comprometemos em não comercializá-los. As suas
                  informações pessoais são enviadas a terceiros, como transportadoras ou fabricantes ligados a
                  QUIMICAL, somente com sua autorização expressa. Esses dados são utilizados para execução de
                  contratos, emissão de notas fiscais de saída dos produtos comercializados ou conhecimento de
                  transporte de serviços de frete realizados. Seus dados não será compartilhado com nenhuma
                  empresa, exceto sem sua expressa concordância.
                </p>
              </section>
            </div>
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
};

export default Privacy;
